import { render, staticRenderFns } from "./ControlMonitoring.vue?vue&type=template&id=356b244a&scoped=true"
import script from "./ControlMonitoring.vue?vue&type=script&lang=js"
export * from "./ControlMonitoring.vue?vue&type=script&lang=js"
import style0 from "./ControlMonitoring.vue?vue&type=style&index=0&id=356b244a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356b244a",
  null
  
)

export default component.exports